module.exports = __webpack_public_path__ + "img/austria_combined_col.a774c396.png";